import { Validators } from "@angular/forms";

export function roomingGroup (fb: any) {
    return fb.array([]);
}

/**
 * rooming Group
 * @param fb : FormBuilder
 */
export function roomingGroupInArray (fb: any) {
    return fb.group({
        adult: fb.control(0, Validators.required),
        child: fb.control(0, Validators.required),
        infant: fb.control(0, Validators.required)
    });
}
